<template>
    <BaseModal :title="title" :width="320" v-model="show">
        <FormModel :action="submit" :model="form" :rules="rules" v-on="$listeners">
            <a-alert :show-icon="true" type="warning">
                <div slot="message">被邀请的{{roleName}}会收到短信通知</div>
            </a-alert>
            <a-form-model-item label="被邀请人手机号码" prop="mobile" style="margin-top: 15px;">
                <a-input placeholder="请输入被邀请人手机号码" v-model="form.mobile" :disabled="!!memberId"/>
            </a-form-model-item>
            <a-form-model-item label="被邀请人姓名备注">
                <a-input placeholder="可输入姓名备注以便管理，非必填" v-model="form.comment"/>
            </a-form-model-item>
        </FormModel>
    </BaseModal>
</template>

<script>
    import enums from "../../../../../utils/enums";
    import FormModel from "../../../../../comps/FormModel";
    import BaseModal from "../../../../../comps/BaseModal";
    import cache from "../../../../../utils/cache";
    import func from "../../../../../utils/func";

    export default {
        name: "MemberForm",
        props: {album: Object},
        components: {BaseModal, FormModel},
        data() {
            return {
                show: false,
                form: {
                    role: "",
                    mobile: "",
                    comment: "",
                    platform: enums.Platform,
                },
                memberId: "",
                rules: {
                    mobile: {required: true, message: "请输入被邀请人手机号码"}
                }
            }
        },
        computed: {
            title() {
                return `添加${this.roleName}`;
            },
            roleName() {
                return enums.Role.getName(this.form.role);
            }
        },
        methods: {
            open(role, item) {
                this.show = true;
                this.form.role = role;
                if (func.isDefined(item)) {
                    this.memberId = item.id;
                    this.form.mobile = item.user.mobile;
                    this.form.comment = item.comment[role];
                } else {
                    this.memberId = "";
                    this.form.mobile = "";
                    this.form.comment = "";
                }
            },
            close() {
                this.show = false;
            },
            submit() {
                let promise = this.memberId === ""
                    ? cache.v1.album.member.create(this.album.id, this.form)
                    : cache.v1.album.member.comment(this.album.id, this.memberId, this.form.role, this.form.comment);
                return promise.then(this.close);
            }
        }
    }
</script>

<style scoped>

</style>
